<template>
  <div>
    <p class="cm-mg-p-wzd">1. {{ $t('production.defects_categories_info') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12">
        <select-businesses-component
          ref="select-businesses"
          :showLoading="false"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Businesses from 'src/components/Selects/Businesses.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';

export default {
  components: {
    [Businesses.name]: Businesses,
  },

  data() {
    return {
      model: {
        id: null,
        name: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      businesses: null,
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },

    clearSelectedBusinesses() {
      this.$refs.select.$refs.select_associations_ids.selectedInitial = [];
      this.$refs.select.$refs.businesses_ids.selectedInitial = [];
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillDefectsCategoryForm', 'firstStep', this.model);
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }

            return false;
          } else return true;
        });
    },
  },

  mounted() {
    this.showHideLoading(true);
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.id = editForm.id;
      this.model.name = editForm.name;
    }
    setTimeout(() => {
      this.showHideLoading();
    }, 1300);
  },
};
</script>
<style></style>
